<span [countUp]="countTo" [options]="getCountUpOptions()" (complete)="onComplete()" *ngIf="!isComplete; else counterComplete">{{ from }}</span>
<ng-template #counterComplete>{{ countTo | number: '1.0' : currentLang() }}</ng-template>